import { render, staticRenderFns } from "./OzDrawerConfirmationDialog.vue?vue&type=template&id=3c7d628a&"
import script from "./OzDrawerConfirmationDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzDrawerConfirmationDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports